var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { greys, error } from "@irati/ui/src/global/colors";
import { Dosis } from "@irati/ui/src/global/fonts";
import { Caption } from "@irati/ui/src/Labels";
import Flex from "@irati/ui/src/Flex";
import media from "@irati/ui/src/global/media";
export var Container = styled(Flex)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  background-color: ", ";\n\n  ", "\n"], ["\n  width: 100%;\n  background-color: ", ";\n\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.utility.white;
}, media.tablet(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: 10px 0;\n  "], ["\n    padding: 10px 0;\n  "]))));
export var ImgWrapper = styled(Flex)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  height: 100px;\n  margin-right: ", ";\n"], ["\n  height: 100px;\n  margin-right: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.two;
});
export var Img = styled.img(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 100px;\n  height: 100px;\n  ", "\n"], ["\n  width: 100px;\n  height: 100px;\n  ", "\n"])), function (_a) {
    var autoHeight = _a.autoHeight;
    return autoHeight && "height: auto;";
});
export var Description = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  flex: 1 0 auto;\n  padding-right: 10px;\n\n  ", "\n"], ["\n  flex: 1 0 auto;\n  padding-right: 10px;\n\n  ",
    "\n"])), media.tablet(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    max-width: 160px;\n  "], ["\n    max-width: 160px;\n  "]))));
export var SubTitle = styled(Caption).attrs({ flush: true })(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  margin-top: ", ";\n  color: ", ";\n"], ["\n  margin-top: ", ";\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.one;
}, greys.mediumDark);
export var Fiscal = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  flex: 0 0 auto;\n  margin-left: auto;\n"], ["\n  flex: 0 0 auto;\n  margin-left: auto;\n"])));
export var Amount = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  ", "\n  font-size: 30px;\n  line-height: 35px;\n  margin-bottom: 5px;\n  text-align: right;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n  font-size: 30px;\n  line-height: 35px;\n  margin-bottom: 5px;\n  text-align: right;\n  ",
    "\n  ",
    "\n  ",
    "\n  ",
    "\n  ",
    "\n"])), Dosis, function (_a) {
    var pending = _a.pending;
    return pending &&
        "\n    color: " + greys.medium + ";\n  ";
}, function (_a) {
    var cancelled = _a.cancelled;
    return cancelled &&
        "\n    color: " + greys.medium + ";\n  ";
}, function (_a) {
    var failed = _a.failed;
    return failed &&
        "\n    color: " + error + ";\n  ";
}, function (_a) {
    var spent = _a.spent;
    return spent &&
        "\n    color: " + greys.black + ";\n  ";
}, function (_a) {
    var cleared = _a.cleared;
    return cleared &&
        "\n    color: " + greys.black + ";\n  ";
});
export var Status = styled(Caption).attrs({
    flush: true,
    bold: true
})(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  color: #26B4AE;\n  text-align: right;\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  color: #26B4AE;\n  text-align: right;\n  ",
    "\n  ",
    "\n  ",
    "\n  ",
    "\n"])), function (_a) {
    var pending = _a.pending;
    return pending &&
        "\n    color: " + greys.medium + ";\n  ";
}, function (_a) {
    var cancelled = _a.cancelled;
    return cancelled &&
        "\n    color: " + greys.mediumDark + ";\n  ";
}, function (_a) {
    var failed = _a.failed;
    return failed &&
        "\n    color: " + error + ";\n  ";
}, function (_a) {
    var spent = _a.spent;
    return spent &&
        "\n    color: " + greys.black + ";\n  ";
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;
